import http from "../../http-common";

class EventRightSideRelatedEventsService {
    getEventRightSideRelatedEventsService(eventPath: string) {
        return http.get(`/right-side-section/events/related-events/${eventPath}`);
    }
}

export default new EventRightSideRelatedEventsService();
